// Map question text and survey question text should be translated within appConfig.js
// Do not edit text within curly brackets, ie: {abc}
// Format: "<ComponentName>.<Description>": "<Text>"

module.exports = ({
    "polyline": "路线",
    "icon": "位置",
    "polygon": "范围",

    // (optional) {branch_name} can be used to display the branch display name in the document title
    "DocumentTitle.map_page": "{branch_name} | 地图",
    "DocumentTitle.error_page": "{branch_name} | 上报错误",
    "DocumentTitle.end_page": "{branch_name} | 完成",
    "DocumentTitle.intro_modal": "{branch_name} | 介绍",
    "DocumentTitle.info_modal": "{branch_name} | 信息",
    "DocumentTitle.survey_modal": "{branch_name} | 问卷",

    "Landing.header": "欢迎!",
    "Landing.main_copy": "请和我们分享一下您的社区生活，帮助我们更好地了解您的需求。",
    "Landing.back_to_map": "回到地图",
    "Landing.start_answering": "开始",
    "Landing.data.header": "数据应用",
    "Landing.data.copy": "我们将严格保护您的隐私。我们采集的所有数据将只用于内部研究。谢谢您的合作！",
    "Landing.help.header": "使用指南",
    "Landing.help.copy": "您可以在地图上通过放置位置点、绘制路径、选择区域的方式描述您的地点。您也可以通过位置搜索来获取地点信息。要改变地图的显示范围和显示方式，请拖拽，放大，或缩小地图，或者在地图和卫星图之间切换。",
    "Landing.feedback": "联系我们",

    "MapContainer.continue": "继续",
    "MapContainer.back_button": "返回地图",
    "MapContainer.info_button": "使用指南",
    "MapContainer.finish_button": "您已经完成了地图上的所有操作",
    "MapContainer.submit": "提交",
    "MapContainer.mapButtonInfo": "缩放到指定区域",
    "MapContainer.roadmap": "地图",
    "MapContainer.satellite": "卫星图",


    "CancelButton.text": "取消",

    "IconDrawer.expand_drawer": "展开",
    "IconDrawer.instructions": "绘制",

    "LayerToggle.roadmap": "地图",
    "LayerToggle.satellite": "卫星图",

    "ConfirmationPopup.done": "完成",
    "ConfirmationPopup.cancel": "取消",

    "PolygonDraw.default_message": "请点击任意位置开始绘制图形",
    "PolygonDraw.alternative_message": "请调整点的位置以调整形状",

    "PolylineDraw.default_message": "请点击任意位置开始绘制路线",
    "PolylineDraw.alternative_message": "请调整点的位置以调整路线",

    "IconDrop.default_message": "请点击任意位置放置地点",
    "IconDrop.alternative_message": "请拖拽点的位置以调整至适当位置",

    "EditModal.delete": "删除",
    "EditModal.save": "保存",
    "EditModal.cancel": "取消",
    "EditModal.textarea_placeholder": "联系我们 或点击保存",
    "EditModal.addTitle": "添加您的 {icon_type}",
    "EditModal.editTitle": "编辑您的 {icon_type}",
    "EditModal.reactionTitle": "请告诉我们您的体验",
    "EditModal.starRatingTitle": "您会给这里的体验打几分",
    "EditModal.commentTitle": "关于这个地方，您有什么想让我们了解的么？",
    "EditModal.deleteConfirmation": "Are you sure?",
    "EditModal.deleteConfirmationText": "Removing this {icon_type} cannot be undone.",

    "SearchBox.placeholder": "搜索位置",

    "Survey.submitting": "正在提交...",

    "EndLanding.header": "非常感谢您的参与！",
    "EndLanding.copy": "完成",
    "EndLanding.take_again": "告诉我们更多关于 Chinatown 的记忆，填写下一个地点！",
});



// WEBPACK FOOTER //
// ./src/locales/zh-CN.js